import React, {lazy, Suspense} from "react";
import { Switch } from "@mui/material";
import Loading from "../Loading";
import ErrorBoundary from "../ErrorBoundary";

import { retryLazy } from "../../utils/applicationUtils";

const PhotoUpload = lazy(() =>
  retryLazy(() => import("../PhotoUpload"))
);

const TicketDesigner = ({
  style = {},
  onChange = () => {},
}) => {
  const handleChange = (field, value) => {
    onChange({
      ...style,
      [field]: value,
    });
  };
  return (
    <div
      className="card font-size-14px"
    >
      <div className="card">
        <div className="font-weight-600">Color settings</div>
        <div className="display-flex gap-2 font-size-14px">
          <div className="flex-1">
            <div className="margin-bottom-5px font-size-12px">Background Color</div>
            <input
              type="color"
              value={style.backgroundColor || "#ffffff"}
              onChange={(e) => handleChange("backgroundColor", e.target.value)}
            />
          </div>

          <div className="margin-bottom-1em flex-1">
            <div className="margin-bottom-5px font-size-12px">Text Color</div>
            <input
              type="color"
              value={style.color || "#000000"}
              onChange={(e) => handleChange("color", e.target.value)}
            />
          </div>
        </div>
        <div className="label display-flex align-items-center">
          <Switch 
              checked={Boolean(style.textBackgroundColor)}
              color="success"
              onChange={(e) => handleChange("textBackgroundColor", style.textBackgroundColor ? "": "#ffffff")}
          />
          <div>
              {style.textBackgroundColor? "Has text background" : "No text background"} 
          </div>
        </div>
        {
          style.textBackgroundColor ?
          <div className="margin-bottom-1em">
            <label className="font-size-12px">Text Background Color</label>
            <input
              type="color"
              value={style.textBackgroundColor}
              onChange={(e) => handleChange("textBackgroundColor", e.target.value)}
              className="margin-left-1em"
            />
          </div>
        :
        null
      }
      </div>
      <div className="card margin-top-5px">
      <div className="margin-bottom-1em">
        <div className="font-weight-600">Background image</div>
        <div className="font-size-12px margin-bottom-5px">For best results use a 1200 × 420 px image</div>
        <ErrorBoundary
            errorHeading="Sorry, we could not load the photo upload. Check your internet connection and retry"
            errorContext="TicketDesigner PhotoUpload Lazy-Loading"
        >
          <Suspense fallback={<Loading />}>
            <PhotoUpload 
              defaultImageUrl={style.backgroundImage?.med}
              onChange={image => handleChange("backgroundImage", image)}
              onClickClose={() => handleChange("backgroundImage", null)}
              containerStyle={{
                width: 274,
                height: 95
              }}
            />
          </Suspense>
        </ErrorBoundary>
      </div>
      </div>
    </div>
  );
};
export default TicketDesigner